<template>
  <div class="d-flex justify-center">
    <div style="width: 90%">
      <v-simple-table fixed-header height="240" class="duo-test-table">
        <template v-slot:default>
          <thead>
          <tr>
            <th
              class="white--text"
              style="background: #1289f8; min-width: 200px; max-width: 200px;"
              v-for="(header, index) in computedHeaders"
              :class="header.class"
              :style="`min-width: ${header.width}; max-width: ${header.width}; ${header.stickyLeft ? `position: sticky; left: ${header.stickyLeft}; z-index: 4`: ''}`"
              :key="'header' + index">
              {{header.text}}
            </th>
          </tr>
          </thead>
          <tbody v-if="items && items.length > 0 && items[0] && items[0].lessons.length > 0">
          <tr v-for="(item, index) in items[0].lessons" :key="'item' + index">
            <td class="sticky-left" style="position: sticky; left: 0px; z-index: 3; background: white">
              {{item.className}}
            </td>
            <td>
              {{item.time}}
            </td>
            <td>
              <b>{{item.lessonTestName}}</b>
            </td>
            <td class="text-center">
              <span
                @click="handleViewDetailScore(item.lmsResultLink)"
                style="color: #0180C7; cursor: pointer"
                v-if="item.correctQuestion !== null && item.totalQuestion !== null"
              >{{item.correctQuestion}}/{{item.totalQuestion}}</span>
            </td>
            <template v-if="parseInt(subjectId) === TIENG_ANH">
              <td class="text-center">
                <span v-if="item.listeningScore">{{item.listeningScore}}</span>
                <img v-else src="../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="text-center">
                <span v-if="item.speakingScore">{{item.speakingScore}}</span>
                <img v-else src="../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="text-center">
                <span v-if="item.readingScore">{{item.readingScore}}</span>
                <img v-else src="../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="text-center">
                <span v-if="item.writingScore">{{item.writingScore}}</span>
                <img v-else src="../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="text-center">
                <span v-if="item.listeningScore">{{item.vocabularyScore}}</span>
                <img v-else src="../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="text-center">
                <span v-if="item.listeningScore">{{item.grammarScore}}</span>
                <img v-else src="../../student_care/assets/empty-data.svg" alt="">
              </td>
            </template>
          </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="computedHeaders.length" class="text-center">
                <span style="color: red">Không có dữ liệu</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { TIENG_ANH } from '@/helpers/constant';

export default {
  name: 'DuoTestTab',
  props: {
    items: {
      type: Array,
      required: true,
    },
    subjectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      TIENG_ANH,
    };
  },
  computed: {
    computedHeaders() {
      // eslint-disable-next-line radix
      if (parseInt(this.subjectId) !== TIENG_ANH) {
        return [
          {
            text: 'Tên lớp',
            width: '150px',
            stickyLeft: '0px',
          },
          {
            text: 'Ngày kiểm tra',
            width: '150px',
          },
          {
            text: 'Buổi kiểm tra',
            width: '150px',
          },
          {
            text: 'Điểm',
            class: 'text-center',
            width: '150px',
          },
        ];
      }
      return [
        {
          text: 'Tên lớp',
          width: '150px',
          stickyLeft: '0px',
        },
        {
          text: 'Ngày kiểm tra',
          width: '150px',
        },
        {
          text: 'Buổi kiểm tra',
          width: '150px',
        },
        {
          text: 'Điểm tổng',
          class: 'text-center',
          width: '75',
        },
        {
          text: 'Nghe',
          class: 'text-center',
          width: '75',
        },
        {
          text: 'Nói',
          class: 'text-center',
          width: '75',
        },
        {
          text: 'Đọc',
          class: 'text-center',
          width: '75',
        },
        {
          text: 'Viết',
          class: 'text-center',
          width: '75',
        },
        {
          text: 'Từ vựng',
          class: 'text-center',
          width: '75',
        },
        {
          text: 'Ngữ pháp',
          class: 'text-center',
          width: '75',
        },
      ];
    },
  },
  methods: {
    handleViewDetailScore(link) {
      if (link) {
        window.open(link);
      }
    },
  },
};
</script>

<style lang="scss">
.duo-test-table {
  tbody {
    tr:hover {
      td.sticky-left {
        background: #eeeeee !important;
      }
    }
  }
}
</style>
